<ion-chip color="light" class="karma-chip">
  <ion-avatar>
    <img src="../../../assets/images/badge-images/karma.png" />
  </ion-avatar>
  <ion-label
    ><strong>+{{ amount }}</strong></ion-label
  >
</ion-chip>
